export default __webpack_public_path__ + "static/media/onboardingAsideMb.47ae939d.png";